import Masonry from 'masonry-layout';

export default class Blog {
  constructor(section) {
    this.el = section.el;
    this.blogSelector = '[data-article-list]';
    this.imageSelector = '[data-rimg]';
    this._layoutGrid = this._layoutGrid.bind(this);
    this.grid = null;

    this.blogMasonry = this.el.querySelector(this.blogSelector);
    this.blogImages = this.el.querySelectorAll(this.imageSelector);

    if (this.blogMasonry) {
      this._blogMasonry();
    }
  }

  onSectionUnload() {
    if (this.grid) {
      this.grid.destroy();
      this.grid = null;
    }

    for (let i = 0; i < this.blogImages.length; i += 1) {
      this.blogImages[i].removeEventListener('rimg:loaded', this._layoutGrid);
    }
  }

  _blogMasonry() {
    // Set up masonry grid
    this.grid = new Masonry(this.blogMasonry, {
      itemSelector: '[data-article-item]',
      columnWidth: '.article-item-grid-sizer',
      gutter: '.article-item-gutter-sizer',
      percentPosition: true,
    });

    this._layoutGrid = this.grid.layout.bind(this);

    for (let i = 0; i < this.blogImages.length; i += 1) {
      this.blogImages[i].addEventListener('rimg:loaded', this._layoutGrid);
    }
  }

  _layoutGrid() {
    if (!this.grid) {
      return;
    }

    this.grid.layout();
  }
}

